export default __webpack_public_path__ + "static/media/warning.dfa6d509.svg";